import Component from "react-pure-render/component";
import React from "react";
import Isvg from "react-inlinesvg";
import moment from "moment";
import Griddle from "griddle-react";
import Tooltip from "rc-tooltip";
import Modal from "../components/modal.react";
import InputCustom from "../components/inputCustom.react";

import { addNotificationsForInvalidFields } from "../lib/validationWeb";

class ActionComponent extends Component {
  onDeleteMenu = () => {
    const { openRemoveMenuModal } = this.props.metadata.customComponentMetadata;
    const uid = this.props.rowData.uid;
    openRemoveMenuModal(uid);
  };

  onEditMenu = () => {
    const { openEditMenuModal } = this.props.metadata.customComponentMetadata;
    const placeholder = this.props.rowData.placeholder;
    openEditMenuModal(placeholder);
  };

  render() {
    return (
      <div>
        <Tooltip
          placement="bottom"
          trigger={["click", "hover"]}
          overlay={
            <div className="popover">
              <a onTouchTap={this.onEditMenu}>edytuj</a>
              <br />
              <a onTouchTap={this.onDeleteMenu}>usuń</a>
            </div>
          }
          getTooltipContainer={() => document.getElementById("wrapper")}
        >
          <div className="icon-table link" />
        </Tooltip>
      </div>
    );
  }
}

class NameComponent extends Component {
  render() {
    const { defaultLocale } = this.props.metadata.customComponentMetadata;
    const name = this.props.rowData.menuTranslations[defaultLocale].name;
    return <span>{name}</span>;
  }
}

export default class Table extends Component {
  static propTypes = {
    actions: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
  }

  onRowClick = (row, e) => {
    if (e.target.className !== "icon-table link") {
      const { history, params: { slug } } = this.props;
      history.pushState(
        "menus/:placeholder",
        `/menus/${row.props.data.placeholder}`,
        {}
      );
    }
  };

  onChangeSort = field => {
    if (field === "name") {
      const {
        actions,
        notificationSystem,
        menus: {
          menus: { search: menusSearch, meta: menusMeta, sort: menusSort }
        }
      } = this.props;
      if (field === "when") {
        field = "whenOccured";
      }
      actions.setPagesListsPaginationPage(0);
      let isDirectionAscending = menusSort.isDirectionAscending;
      if (field === menusSort.field) {
        isDirectionAscending = !isDirectionAscending;
      }
      actions.setSortMenus(field, isDirectionAscending);
      actions.getMenus(menusMeta, menusSort).then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, notificationSystem);
        }
      });
    }
  };

  removeMenu = () => {
    const {
      actions,
      notificationSystem,
      menus: { menus: { isRemoveModalVisible, meta: menusMeta } },
      params: { slug }
    } = this.props;
    actions.removeMenu(isRemoveModalVisible).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        let notification = {
          level: "success",
          message: "Usunięto wpis!",
          position: "br",
          autoDismiss: 5,
          dismissible: true
        };
        notificationSystem.addNotification(notification);
        actions.getMenus(menusMeta).then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
      }
    });
    actions.setIsRemoveMenuModalVisible(false);
  };

  openRemoveMenuModal = uid => {
    const { actions } = this.props;
    actions.setIsRemoveMenuModalVisible(uid);
  };

  closeRemoveMenuModal = () => {
    const { actions } = this.props;
    actions.setIsRemoveMenuModalVisible(false);
  };

  updateMenu = () => {
    const {
      actions,
      notificationSystem,
      menus: {
        menus: { isEditModalVisible, meta: menusMeta, entities: menus }
      },
      locales: { locales: { defaultLocale } }
    } = this.props;
    const data = {
      name: menus.getIn([
        isEditModalVisible,
        "menuTranslations",
        defaultLocale,
        "name"
      ])
    };
    const uid = menus.getIn([
      isEditModalVisible,
      "menuTranslations",
      defaultLocale,
      "uid"
    ]);
    actions.updateMenuTranslation(data, uid).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        actions.getMenus(menusMeta).then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
      }
    });
    actions.setIsEditMenuModalVisible(false);
  };

  openEditMenuModal = uid => {
    const { actions } = this.props;
    actions.setIsEditMenuModalVisible(uid);
  };

  closeEditMenuModal = () => {
    const { actions } = this.props;
    actions.setIsEditMenuModalVisible(false);
  };

  render() {
    const {
      config,
      actions,
      tableWidth,
      tableHeight,
      locales: { locales: { defaultLocale } },
      menus: {
        menus: {
          isRemoveModalVisible,
          isEditModalVisible,
          entities: menus,
          meta: { currentPage, limit },
          sort: menusSort,
          loading
        }
      }
    } = this.props;

    let columnMetadata = [
      {
        columnName: "index",
        displayName: "Lp.",
        cssClassName: "table-unsortable",
        visible: true
      },
      {
        columnName: "name",
        displayName: "Nazwa",
        cssClassName: "table-unsortable",
        visible: true,
        customComponent: NameComponent,
        customComponentMetadata: {
          defaultLocale
        }
      },
      {
        columnName: "actions",
        displayName: "Akcje",
        visible: true,
        cssClassName: "data-table-file table-unsortable",
        customComponent: ActionComponent,
        customComponentMetadata: {
          openRemoveMenuModal: this.openRemoveMenuModal,
          openEditMenuModal: this.openEditMenuModal
        }
      }
    ];

    let data = [];
    let index = 0;

    if (menus) {
      menus.forEach(function(menu) {
        let menuData = menu.toJS();
        index++;
        menuData.index = index + currentPage * limit;
        data = data.concat(menuData);
      });
    }

    const inputCustomProps = {
      feature: "menus",
      actions: actions,
      field: ["menuTranslations", defaultLocale, "name"],
      entity: menus.getIn([isEditModalVisible]),
      uid: isEditModalVisible
    };

    return (
      <div>
        <Griddle
          results={data}
          columnMetadata={columnMetadata}
          tableClassName="data-table"
          useGriddleStyles={false}
          columns={["index", "name", "actions"]}
          onRowClick={this.onRowClick}
          enableSort={false}
          enableInfiniteScroll={false}
          showPager={false}
          bodyHeight={tableHeight}
          resultsPerPage={100}
          useExternal={true}
          externalChangeSort={this.onChangeSort}
          externalSortColumn={menusSort.field}
          externalSortAscending={menusSort.isDirectionAscending}
          externalSetPage={() => {}}
          externalSetFilter={() => {}}
          externalSetPageSize={() => {}}
          externalMaxPage={() => {}}
          externalCurrentPage={() => {}}
          noDataMessage={loading ? "trwa ładowanie danych..." : "Brak danych"}
          sortAscendingComponent={
            <Isvg className="fa fa-sort-asc" src="/assets/img/icon_sort.svg" />
          }
          sortDescendingComponent={
            <Isvg className="fa fa-sort-desc" src="/assets/img/icon_sort.svg" />
          }
        />
        {isRemoveModalVisible && (
          <Modal
            closeModalAction={this.closeRemoveMenuModal}
            enterAction={this.removeMenu}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Uwaga!</h3>
              <p>Czy na pewno usunąć?</p>
              <button className="error" onTouchTap={this.removeMenu}>
                Tak
              </button>
              <button className="info" onTouchTap={this.closeRemoveMenuModal}>
                Nie
              </button>
            </div>
          </Modal>
        )}

        {isEditModalVisible && (
          <Modal
            closeModalAction={this.closeEditMenuModal}
            enterAction={this.updateMenu}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Edytuj tytuł wpisu</h3>
              <InputCustom {...inputCustomProps} />
              <button className="error" onTouchTap={this.updateMenu}>
                Tak
              </button>
              <button className="info" onTouchTap={this.closeEditMenuModal}>
                Nie
              </button>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/menus/table.react.js